module.exports = __webpack_public_path__ + "static/img/home-img.d437777.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/home-img.png
// module id = LnOV
// module chunks = 1